<template>
  <div class="levelTable">
    <b-loading
      :is-full-page="false"
      v-model="isLoading"
    />
    <table class="table is-narrow is-bordered center is-fullwidth">
      <tbody>
        <tr
          v-for="i in 10"
          :key="i"
          :class="levelClass(i)"
          @click="gotoLevel(i)"
        >
          <td>Level {{ i }}</td>
          <td><MasteryLevel :level="i" /></td>
          <td style="padding: 0 0 0 0">
            <div class="level-row">
              <PlayerWinStats :stats="levelStats(i)" />
              <div class="level-icon">
                <img
                  v-if="levelClass(i) === 'level--current'"
                  src="@/assets/img/chess/bonus.png"
                  class="level-icon__bonus"
                />
                <img
                  v-else-if="!stats || i > stats.rating"
                  src="@/assets/img/chess/lock.png"
                  class="level-icon__lock"
                />
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import MasteryLevel from "@/components/stats/MasteryLevel.vue";
import PlayerWinStats from "@/components/stats/PlayerWinStats.vue";
import { MatchesAPI } from "@/services/api";

export default {
  components: { MasteryLevel, PlayerWinStats },

  props: ["username"],

  data() {
    return {
      stats: null,
    };
  },

  computed: {
    isLoading() {
      return this.stats == null;
    },
  },

  methods: {
    levelStats(level) {
      if (!this.stats || !this.stats.rating_statistics) return null;
      // rating_statistics is sparse (no entry for a level never played), and
      // each entry carries its own `rating` field identifying which level it
      // is for — it must be matched by that field, not by array position,
      // otherwise a missing level shifts every stat after it onto the wrong row.
      return this.stats.rating_statistics.find((entry) => entry.rating === level) || null;
    },

    levelClass(level) {
      if (!this.stats) return "level--future";
      if (this.stats.rating === level) return "level--current";
      if (this.stats.rating === 0 && level === 1) return "level--current";
      if (this.stats.rating > level && level === 10) return "level--current";
      if (this.stats.rating > level) return "level--past";
      return "level--future";
    },

    gotoLevel(level) {
      if (level === 1 || level <= this.stats.rating) {
        this.$emit("onSelectLevel", level);
      }
    },
  },

  created() {
    if (!this.username) return;
    MatchesAPI.getPlayerStats(this.username).then((data) => (this.stats = data));
  },
};
</script>

<style scoped>
.levelTable {
  position: relative;
}

.table td {
  overflow: visible;
  vertical-align: middle;
  height: 50px;
}

.level--past {
  background-color: #674ea7;
  color: whitesmoke;
  cursor: pointer;
}

.level--current {
  background-color: #b400b4;
  color: whitesmoke;
  cursor: pointer;
}

.level--future {
  background-color: lightgray;
}

.level-row {
  display: flex;
  align-items: center;
  width: 100%;
  padding-left: 5px;
}

.level-icon {
  flex-shrink: 0;
  width: 50px;
  height: 47px;
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.level-icon__bonus {
  height: 47px;
  width: 47px;
  object-fit: cover;
}

.level-icon__lock {
  height: 27px;
  object-fit: cover;
}
</style>
